export function sortByPropName({params, field_name}) {
    params.sort((a,b) => (a[field_name] > b[field_name]) ? 1 : ((b[field_name] > a[field_name]) ? -1 : 0))
}